/* ==========================================================================
   Therapies section — media interactions
   • Image slider: Swiper with fade (crossfade) + clickable pagination dots
   • Video: click-to-play (native <video> inline, or YouTube/Vimeo iframe)
   Self-initialising; re-inits on Shopify theme-editor section load.
   Requires Swiper (JS + CSS) to be loaded globally by the theme.
   ========================================================================== */
(function () {
  function initSlider(el) {
    if (el.dataset.ttInit) return;
    el.dataset.ttInit = '1';
    /* eslint-disable no-undef */
    new Swiper(el, {
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      speed: 800,
      grabCursor: true,
      autoplay: { delay: 4000, disableOnInteraction: false, pauseOnMouseEnter: true },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
    /* eslint-enable no-undef */
  }

  function initSliders(scope) {
    var root = scope || document;
    var sliders = root.querySelectorAll('[data-tt-slider]');
    if (!sliders.length) return;
    /* Swiper may load after us — wait for window load, then retry once. */
    if (typeof Swiper === 'undefined') {
      window.addEventListener('load', function () { initSliders(scope); }, { once: true });
      return;
    }
    sliders.forEach(initSlider);
  }

  function initVideo(wrap) {
    if (wrap.dataset.ttInit) return;
    var btn = wrap.querySelector('[data-tt-play]');
    if (!btn) return;
    wrap.dataset.ttInit = '1';

    btn.addEventListener('click', function () {
      var native = wrap.querySelector('video');
      var embed = wrap.getAttribute('data-embed');
      if (native) {
        wrap.classList.add('is-playing');
        native.play();
      } else if (embed) {
        var f = document.createElement('iframe');
        f.className = 'therapies__video-iframe';
        f.src = embed;
        f.setAttribute('allow', 'autoplay; fullscreen; encrypted-media; picture-in-picture');
        f.setAttribute('allowfullscreen', '');
        f.setAttribute('frameborder', '0');
        wrap.appendChild(f);
        wrap.classList.add('is-playing');
      }
    });
  }

  function init(scope) {
    var root = scope || document;
    initSliders(root);
    root.querySelectorAll('[data-tt-video]').forEach(initVideo);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  }

  /* Shopify theme editor: re-init when this section is (re)loaded */
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
